// React, Types & Routing
import Content from "Types/Content";
import React, { MouseEventHandler, useState } from "react";
import { RouteProps } from "react-router";

// Components & Styles
import { Container } from "react-bootstrap";
import Styles from "./styles.module.scss";
import { RickMortyApp } from "./components/RickMortyApp";

const RickMorty: React.FC<RouteProps> = () => {
  const [name, setName] = useState("");

  const handleGraph: MouseEventHandler<HTMLButtonElement> = () => {
    setName("GraphQL");
  };

  const handleRest: MouseEventHandler<HTMLButtonElement> = () => {
    setName("Rest");
  };

  const handleBack: MouseEventHandler<HTMLButtonElement> = () => {
    setName("");
  };

  return (
    <>
      {name === "" ? (
        <Container className={Styles.fullScreen}>
          <button className={Styles.mainButton} onClick={handleGraph}>
            GraphQL
          </button>

          <button className={Styles.mainButton} onClick={handleRest}>
            API Rest
          </button>
        </Container>
      ) : (
        <>
          <Container>
            <button className={Styles.backButton} onClick={handleBack}>
              Volver
            </button>
            <RickMortyApp mode={name} />
          </Container>
        </>
      )}
    </>
  );
};

export default new Content({
  Component: RickMorty,
  title: "Rick & Morty ",
  route: "rick-morty-api",
  tags: ["frontend", "valentin", "galfre", "api", "debounce", "bootstrap"]
});
